module.exports = __webpack_public_path__ + "assets/0910b4c3c195287ee9f394d02368fdb1.svg";